import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate} from 'react-router-dom';
import { getContentList } from '../../features/notice/noticeSlice';
import { formatDate } from '../../utils/formatDate';
import { Pagination } from "react-bootstrap";
import { setEndpoint, clearEndpoint } from '../../features/notice/noticeSlice';
import "../../css/pagination.css";
import { FadeLoader } from 'react-spinners';
const NoticeList = ({ categoryId, dataStyle, vsData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [pageIndex, setPageIndex] = useState(1);

  const periodDate = useSelector((state) => state.setting.periodDate);
  const contentList = useSelector((state) => state.notice.contentList);
  const categories = useSelector((state) => state.notice.categories || []);
  const settings = useSelector((state) => state.setting.settings);
  const totalCount = useSelector((state) => state.notice.totalCount);  
  const endpoint = useSelector((state) => state.notice.endpoint || `/content?ca=${categoryId}&vs=${vsData}&pi=${pageIndex}&ds=${dataStyle}`) ;
  const LIST_VIEW_COUNT = settings.listViewCount;
  
  const shouldShowLoadMoreButton = (contentList?.length < totalCount) || false;
  const totalPages = totalCount ? Math.ceil(totalCount / LIST_VIEW_COUNT) : 1;

  const [loading, setLoading] = useState(true);

  const moreData = () => {
    dispatch(clearEndpoint());
    setPageIndex((prevIndex) => prevIndex + 1);
  };

  const handlePageChange = (selectedPage) => {
    setPageIndex(selectedPage); 
  };

  const goDetail = (noticeId) => {
    dispatch(setEndpoint(endpoint));
    navigate(`/notice/${noticeId}`);
  };

  //#region useEffect
  useEffect(() => {
    if (vsData === "list") {
      const fetchData = async () => {
        setLoading(true);  
        try {
          if (pageIndex > 1) {
            await dispatch(getContentList(endpoint, true));
          } else {
            await dispatch(getContentList(endpoint));
          }
        } catch (error) {
          console.error("데이터 요청 실패:", error);
        } finally {
          setLoading(false); 
        }
      };
      fetchData();
    }
  }, [dispatch, endpoint, pageIndex, categoryId, vsData]);

  useEffect(() => {
    setPageIndex(1);
  }, [categoryId, vsData]);
  
  //#endregion

  
  return (
    <div>
      {loading ? (
          <FadeLoader
            color="#9a9a9a"
            height={10}
            width={4}
            style={{
              position: "relative",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
            }}
          />
      ) : contentList && contentList.length > 0 ? (
        <ul className="news_list">
          {contentList.map((item, index) => {
            const category = categories.find(cat => cat.id === item.category_id);
            const categoryName = category ? category.name : '카테고리';

            const noticePeriodDate = new Date().getTime() - periodDate * 24 * 60 * 60 * 1000;
            const isLatest = new Date(item.created_at).getTime() >= noticePeriodDate;
            const preview = item.PREVIEW_YN;

            return (
              <li key={index} onClick={() => goDetail(item.id)}>
                <a href={item.link || ''}>
                  <div className="bo-grid-text">
                    {preview === 'Y' && <p>임시저장</p>}
                    {item.category_id && <mark>{categoryName}</mark>}
                    {isLatest && <span className="icon_new lg" title="새로운 알림"></span>}
                    <strong>{item.title}</strong>
                    <span>{formatDate(item.created_at)}</span>
                  </div>
                </a>
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="empty_table">게시물이 없습니다.</div>
      )}

      {dataStyle === "pagging" ? (
        totalPages > 1 && (
          <div className="pagination-container">
            <Pagination>
              <Pagination.Prev
                onClick={() => pageIndex > 1 && setPageIndex(pageIndex - 1)}
                disabled={pageIndex === 1}
              />
              {[...Array(totalPages)].map((_, index) => {
                const page = index + 1;
                return (
                  <Pagination.Item
                    key={page}
                    active={page === pageIndex}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              })}
              <Pagination.Next
                onClick={() => pageIndex < totalPages && setPageIndex(pageIndex + 1)}
                disabled={pageIndex === totalPages}
              />
            </Pagination>
          </div>
        )
      ) : (
        shouldShowLoadMoreButton && (
          <div className="scroll">
            <span className='btn-more' onClick={moreData}>더보기</span>
          </div>
        )
      )}
    </div>
  );
};

export default NoticeList;
